"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("core-js/modules/es6.regexp.replace");

var _react = _interopRequireDefault(require("react"));

var _spoonflower = _interopRequireDefault(require("@sfly/uig-svg-icon/logos-svg/spoonflower"));

require("./SpoonFlowerLogo.css");

var currentPage = typeof window !== 'undefined' && window.location.pathname.replace(/^\/+|\/+$/g, '') || '';

var SpoonFlowerLogo = function SpoonFlowerLogo() {
  return _react.default.createElement("div", {
    className: "spoonflower-desktop-container"
  }, _react.default.createElement("div", {
    className: "spoonflower-text"
  }, "Also visit"), _react.default.createElement("div", {
    className: "spoonflower-logo-wrapper"
  }, _react.default.createElement("a", {
    "aria-label": "Spoonflower",
    "data-linkid": "Spoonflower_logo",
    target: "_blank",
    "data-linkname": "global-header|".concat(currentPage, ":Spoonflower"),
    href: "https://www.spoonflower.com/en/shutterfly?utm_source=shutterfly&utm_medium=referral&utm_campaign=210803_shutterfly&utm_term=global_header&utm_content=intro_creative",
    alt: "Visit Spoonflower"
  }, _react.default.createElement(_spoonflower.default, {
    className: "spoonflower-logo-desktop"
  }), " ")));
};

var _default = SpoonFlowerLogo;
exports.default = _default;